var map = {
	"./amex.svg": "8502",
	"./cup.svg": "ee834",
	"./dc.svg": "fec2",
	"./discover.svg": "8fe6",
	"./jcb.svg": "b6a1",
	"./mastercard.svg": "1b53",
	"./visa.svg": "93b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "311e";